import React from 'react';
import { eFeePropertyNames } from 'types/order/fees/eFeePropertyNames';
import { TextField } from 'ui-toolkit';

export interface IReasonProps {
  baseName: string;
  readOnly: boolean;
}

export const ReasonField: React.FC<IReasonProps> = ({ baseName, readOnly }) => {
  return (
    <TextField
      name={`${baseName}.stringFeePropertyValues.${eFeePropertyNames.Reason}`}
      label={'Reason'}
      placeholder={'Refund'}
      readOnly={readOnly}
    />
  );
};
